/**
 * Customer Deleted List Component
 */
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import type { DeletedCustomer } from '@/modules/Customer/types'
import { useCustomerDeletedList } from '@/modules/Customer/hooks/use-customer-deleted-list'

const Deleted = () => {
    const {
        customers,
        pagination,
        stateComponent,
        params,
        searchInputProps,
        columns,
        handlePageChange,
        handlePageSizeChange,
        handleSortChange,
        t,
    } = useCustomerDeletedList()

    return (
        <Paper className="space-y-2 my-2">
            {stateComponent || (
                <DataTableCustomized<DeletedCustomer>
                    columns={columns}
                    rows={customers}
                    rowKey={(row) => row.customer_id}
                    size="small"
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search_customers'),
                        },
                        settings: {
                            show: true,
                            storageKey: 'customer-deleted-list',
                        },
                    }}
                    stickyHeader={{
                        enabled: true,
                        offsetTopSelector: '#main-header',
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                />
            )}
        </Paper>
    )
}

export default Deleted
